import { render } from "./PhaserGame.vue?vue&type=template&id=d2f32cb4&ts=true"
import script from "./PhaserGame.vue?vue&type=script&lang=ts"
export * from "./PhaserGame.vue?vue&type=script&lang=ts"

import "./PhaserGame.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__